<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99749 14.5853C9.76823 14.5853 9.58065 14.7728 9.58315 15.0021C9.58315 15.2314 9.77073 15.4189 9.99999 15.4189C10.2293 15.4189 10.4168 15.2314 10.4168 15.0021C10.4168 14.7728 10.2293 14.5853 9.99749 14.5853"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.99749 9.58319C9.76823 9.58319 9.58065 9.77077 9.58315 10C9.58315 10.2293 9.77073 10.4169 9.99999 10.4169C10.2293 10.4169 10.4168 10.2293 10.4168 10C10.4168 9.77077 10.2293 9.58319 9.99749 9.58319"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.99749 4.58112C9.76823 4.58112 9.58065 4.76869 9.58315 4.99796C9.58315 5.22722 9.77073 5.4148 9.99999 5.4148C10.2293 5.4148 10.4168 5.22722 10.4168 4.99796C10.4168 4.76869 10.2293 4.58112 9.99749 4.58112"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
